module.exports = __webpack_public_path__ + "static/gallery-2-93abe0728ea7bfa819bed5442c12916a.jpg";